import { IEmailManager } from "../interactor/EmailManager";
import { FormRequestHandler } from "@/forms/FormRequestHandler";
import { FormResponse } from "@/forms/FormResponse";

export class VerifySubjectController {
  public constructor(
    private presenter: IVerifySubjectPresenter,
    private emailManager: IEmailManager
  ) {}

  public init(subject: string, mode: string, token: string) {
    this.presenter.subject = subject;
    this.presenter.mode = mode;
    this.verifySubject(subject, token);
  }

  public verifySubject(subject: string, token: string) {
    const request = this.emailManager.verifySubject(subject, token);

    FormRequestHandler.handle(
      request,
      response => (this.presenter.verifySubjectResponse = response)
    );
  }
}

export interface IVerifySubjectPresenter {
  subject: string;
  mode: string;
  verifySubjectResponse: FormResponse<string>;
}
